import { Link, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { HomePage } from "./FrontPages/HomePage/home_page";
import ContactUS_Page from "./FrontPages/ContactusPage/ContactUS_Page";
import AboutusPage from "./FrontPages/AboutUs/AboutusPage";
import Quincenera from "./FrontPages/QuinceneraPage/quincenera";
import InquiryPage from "./FrontPages/Inquiry/inquiryPage";
import Wedding from "./FrontPages/WeddingPage/wedding";
import { FAQFront } from "./FrontPages/Footer/FAQFront";
import { PrivacyPolicyFront } from "./FrontPages/Footer/privacyPolicyFront";
import { SiteMaps } from "./FrontPages/Footer/SiteMaps";
import React, { useEffect, useRef, useState } from "react";
import BlogPage from "./FrontPages/Blog/blogPage";
import PrivateParties from "./FrontPages/PrivateParties/privateParties";
import { GalleryPage } from "./FrontPages/Gallery/galleryPage";
import { birthday } from "./FrontPages/PrivateParties/FunctionPages/birthday";
import { GalleryDetailsPage } from "./FrontPages/Gallery/galleryDeatilsPage";
import { babyShower } from "./FrontPages/PrivateParties/FunctionPages/babyShower";
import { graduation } from "./FrontPages/PrivateParties/FunctionPages/graduation";
import { engagement } from "./FrontPages/PrivateParties/FunctionPages/engagement";
import { others } from "./FrontPages/PrivateParties/FunctionPages/others";
import FacilityMain from "./FrontPages/Facility/facilityMain";
import { IndividualBlog } from "./FrontPages/Blog/individualBlog";
import { _toLeftRightCenter } from "chart.js/helpers";
import designAndDecor from "./FrontPages/DesignAndDecor/designAndDecor";
import { corefetch, ImageURL } from "../Util/axios_core_helper";
import { TermsandConditionF } from "../Modules/FrontPages/Footer/TermsandConditionF";
import Vendor from "./FrontPages/Vendor/vendor";
import { ToastContainer } from "react-toastify";
import PaymentMethods from "./FrontPages/PaymentMethods/paymentMethods";
import { Helmet } from "react-helmet";

export const LayoutHome = () => {
  // const pathSegments = window.location.pathname.split("/").filter(Boolean);
  // let activeMenu;
  // let activeMenuid;
  // if ((pathSegments.length = 1)) {
  //   activeMenu = window.location.pathname.split("/")[1].toLowerCase();
  // } else if (pathSegments.length > 1) {
  // let activeMenu = window.location.pathname.split("/")[1].toLowerCase();
  // let activeMenuid = window.location.pathname.split("/")[2].toLowerCase();
  // }

  let pathSegments = window.location.pathname.split("/");
  let activeMenu = pathSegments[1] ? pathSegments[1].toLowerCase() : ""; // Default to an empty string
  let activeMenuid = pathSegments[2] ? pathSegments[2].toLowerCase() : ""; // Default to an empty string

  const [InquiryModal, setInquiryModal] = useState(false);
  const [CloseModal, setCloseModal] = useState(1);
  const [loadComponent, setloadComponent] = useState(null);
  const [socialLinks, setSocialLinks] = useState(null);
  const [ContactList, setContactList] = useState([]);
  const [BallroomData, setBallroomData] = useState([]);
  const [SbroucherFiles, setSBroucherFiles] = useState();
  const [CbroucherFiles, setCBroucherFiles] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [CisLoading, setCIsLoading] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [socialMediaLinks, setsocialMediaLinks] = useState([]);
  const [allSocialMediaLinks, setAllSocialMediaLinks] = useState([]);
  const [firstFourLinks, setFirstFourLinks] = useState([]);
  const [remainingIcons, setRemainingIcons] = useState([]);
  const buttonRef = useRef(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target) // Ignore button clicks
      ) {
        setIsOpen(false);
        setIsDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const ResetModal = (e) => {
    setloadComponent(
      <InquiryPage InquiryModal={InquiryModal} ResetModal={ResetModal} />
    );
    setCloseModal((prevkey) => prevkey + 1);
  };

  useEffect(() => {
    if (!loadComponent && InquiryModal) {
      setloadComponent(
        <InquiryPage InquiryModal={InquiryModal} ResetModal={ResetModal} />
      );
    }
  }, [InquiryModal]);

  const openModal = (e) => {
    e.preventDefault();
    $("#inquiry").modal("show");
    setInquiryModal(true);
  };

  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await corefetch("ContactUs/GetContactList");
        if (list && list.length > 0) {
          setContactList(list);
        } else {
          setContactList([]);
        }
      } catch (error) {
        setContactList([]);
        console.error("Error fetching list:", error);
      }
    };
    fetchData();

    fetchBallroomData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch(
          "ContactUs/SocialMediaLinksForFrontend"
        );
        if (response && response.length > 0) {
          setSocialLinks(response[0]);
          setSBroucherFiles(response[0].sBrochureFile);
          setCBroucherFiles(response[0].cBrochureFile);
        } else {
          console.log("No data found on SocialMediaLinksForFrontend");
        }
      } catch (error) {
        console.error("Error fetching social media links:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchSocialMediaLinkData = async () => {
      try {
        const response = await corefetch("ContactUs/GetSocialMediaLinkDetails");
        if (response && response.length > 0) {
          // Sort by sortOrder
          const sortedLinks = response.sort(
            (a, b) => a.sortOrder - b.sortOrder
          );

          // Store all links
          setAllSocialMediaLinks(sortedLinks);

          // First 4 icons
          setFirstFourLinks(sortedLinks.slice(0, 4));

          // Remaining icons
          setRemainingIcons(sortedLinks.slice(4));
        } else {
          console.log("No data found on SocialMediaLinksForFrontend");
          setAllSocialMediaLinks([]);
          setFirstFourLinks([]);
          setRemainingIcons([]);
        }
      } catch (error) {
        console.error("Error fetching social media links:", error);
      }
    };

    fetchSocialMediaLinkData();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await corefetch("ContactUs/BroucherForFrontend");
  //       if (response && response.length > 0) {
  //         setBroucherFiles(response);
  //       } else {
  //         console.log("No data found on BroucherForFrontend");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching brochure files:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const ShandleDownload = async () => {
    debugger;
    setIsLoading(true);

    try {
      const response = await fetch(`${ImageURL}${SbroucherFiles}`, {
        method: "GET",
        credentials: "include",
      });
      if (!response.ok) {
        console.error(`Failed to fetch file: ${SbroucherFiles}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = SbroucherFiles.split("/").pop();
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Error downloading file: ${SbroucherFiles}`, error);
    }
    setIsLoading(false);
  };

  const ChandleDownload = async () => {
    setCIsLoading(true);

    try {
      const response = await fetch(`${ImageURL}${CbroucherFiles}`, {
        method: "GET",
        credentials: "include",
      });
      if (!response.ok) {
        console.error(`Failed to fetch file: ${CbroucherFiles}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = CbroucherFiles.split("/").pop();
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Error downloading file: ${CbroucherFiles}`, error);
    }
    setCIsLoading(false);
  };

  const handleItemClick = (id) => {
    navigate("/gallery", { state: { id } });
  };
  const handleVenueClick = (id) => {
    navigate("/facilityMain", { state: { id } });
  };

  const toggleDropdown = (event) => {
    // event.stopPropagation();
    setIsDropdownVisible((prev) => !prev);
  };
  // const toggleDropdownicon = () => {
  //   setIsDropdownVisible((prev) => !prev);
  // };
  const iconMap = {
    facebook: "fi flaticon-facebook-app-symbol",
    twitter: "fi flaticon-twitter",
    linkedin: "fi flaticon-linkedin",
    instagram: "fi flaticon-instagram-1",
  };

  return (
    <>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-K37D8DFFDY"
        ></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-K37D8DFFDY');
      `}
        </script>
        {/* <script async src="https://tag.pearldiver.io/ldc.js?pid=c450c9fa544f18c430bdd02a1b14c91f&aid=16de03f2"></script> */}

        <script type="text/javascript" defer>
          {`
        var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function () {
          var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/59337a50b3d02e11ecc6821d/default';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();
      `}
        </script>
      </Helmet>
      <div className="page-wrapper">
        {/* Start header */}
        <header id="header">
          <div
            className="wpo-site-header wpo-header-style-1"
            id="sticky-header"
          >
            <nav className="navigation navbar navbar-expand-lg navbar-light">
              <div className="container-fluid">
                <div
                  className="row align-items-center"
                  style={{ marginLeft: "-52px", marginTop: "-7px" }}
                >
                  <div className="col-md-3 col-3 d-lg-none d-block">
                    <div className="mobail-menu">
                      <button type="button" className="navbar-toggler open-btn">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar first-angle" />
                        <span className="icon-bar middle-angle" />
                        <span className="icon-bar last-angle" />
                      </button>
                    </div>
                  </div>
                  <div
                    className="col-lg-2 col-md-6 col-6 d-lg-block d-none custom-overrides "
                    style={{ marginLeft: "-5px" }}
                  >
                    {firstFourLinks.length > 0 && (
                      <div className="social-info">
                        <ul>
                          {firstFourLinks.map((social, index) => (
                            <li
                              key={index}
                              title={social.name}
                              onClick={() => window.open(social.link, "_blank")}
                            >
                              <a href="#" className="iconColor">
                                <img
                                  src={`${ImageURL}${social.imagePath}`}
                                  alt={social.name}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div
                    className="col-md-6 col-6 d-lg-none dl-block"
                    style={{ textAlign: "center" }}
                  >
                    <div className="navbar-header">
                      {/* <a className="navbar-brand" href="index.html">
                    
                      <img src="assets/images/meridian.png" />
                    </a> */}
                    </div>
                  </div>
                  <div
                    id="uniqueDivId"
                    className="col-lg-7 col-md-1 col-1 "
                    style={{ marginLeft: "-20px" }}
                  >
                    <div
                      id="navbar"
                      className="collapse navbar-collapse navigation-holder"
                    >
                      <button className="menu-close">
                        <i className="ti-close" />
                      </button>
                      <ul className="nav navbar-nav mb-2 mb-lg-0">
                        <li>
                          <a
                            className={
                              activeMenu == "home" || activeMenu == ""
                                ? "active"
                                : ""
                            }
                            href="/home"
                          >
                            Home
                          </a>
                        </li>
                        <li className="menu-item-has-children">
                          <a
                            className={
                              activeMenu == "quinceanera" ||
                              activeMenu == "wedding" ||
                              activeMenu == "corporate" ||
                              activeMenu == "private-parties" ||
                              activeMenu == "birthday" ||
                              activeMenu == "babyshower" ||
                              activeMenu == "graduation" ||
                              activeMenu == "engagement" ||
                              activeMenu == "others" ||
                              activeMenu == "privateparties"
                                ? "active"
                                : ""
                            }
                            href="#"
                          >
                            Events
                          </a>
                          <ul className="sub-menu">
                            <li>
                              <a
                                className={
                                  activeMenu == "quinceanera" ? "active" : ""
                                }
                                href="/quinceanera"
                              >
                                Quinceanera
                              </a>
                            </li>
                            <li>
                              <a
                                className={
                                  activeMenu == "wedding" ? "active" : ""
                                }
                                href="/wedding"
                              >
                                Wedding
                              </a>
                            </li>
                            <li>
                              <a href="/corporate">Corporate</a>
                            </li>
                            <li className="menu-item-has-children">
                              <a
                                className={
                                  activeMenu == "birthday" ||
                                  activeMenu == "babyshower" ||
                                  activeMenu == "graduation" ||
                                  activeMenu == "engagement" ||
                                  activeMenu == "others" ||
                                  activeMenu == "privateparties"
                                    ? "active"
                                    : ""
                                }
                                href="/privateParties"
                              >
                                Private Parties
                              </a>
                              <ul className="sub-menu sub-menu-Dum">
                                <li>
                                  <a
                                    className={
                                      activeMenu == "birthday" ? "active" : ""
                                    }
                                    href="/birthday"
                                  >
                                    Birthday
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={
                                      activeMenu == "babyshower" ? "active" : ""
                                    }
                                    href="/babyShower"
                                  >
                                    Baby Shower
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={
                                      activeMenu == "graduation" ? "active" : ""
                                    }
                                    href="/graduation"
                                  >
                                    Graduation
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={
                                      activeMenu == "engagement" ? "active" : ""
                                    }
                                    href="/engagement"
                                  >
                                    Engagement
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={
                                      activeMenu == "others" ? "active" : ""
                                    }
                                    href="/others"
                                  >
                                    Others
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item-has-children">
                          <a
                            className={
                              activeMenu == "facilitymain" ? "active" : ""
                            }
                            href="#"
                          >
                            Venues
                          </a>
                          <ul className="sub-menu">
                            {BallroomData.map((ballroom) => (
                              <li key={ballroom.facilityID}>
                                <a
                                  className={
                                    activeMenu == "facilitymain" &&
                                    activeMenuid == `${ballroom.facilityID}`
                                      ? "active"
                                      : ""
                                  }
                                  href={`/facilityMain/${ballroom.facilityID}`}
                                >
                                  {ballroom.facilityName}
                                </a>
                                <br />
                              </li>
                            ))}
                          </ul>
                        </li>

                        <li>
                          <a
                            className={activeMenu == "about-us" ? "active" : ""}
                            href="/About-us"
                          >
                            About US
                          </a>
                        </li>
                        <li className="menu-item-has-children">
                          <a
                            className={activeMenu == "gallery" ? "active" : ""}
                            href="#"
                          >
                            Gallery
                          </a>
                          <ul className="sub-menu">
                            {BallroomData.map((ballroom) => (
                              <li key={ballroom.facilityID}>
                                <a
                                  className={
                                    activeMenu == "gallery" &&
                                    activeMenuid == `${ballroom.facilityID}`
                                      ? "active"
                                      : ""
                                  }
                                  href={`/gallery/${ballroom.facilityID}/BallRoom`}
                                  // className="Footer-title-list-value"
                                >
                                  {ballroom.facilityName}
                                </a>
                                <br />
                              </li>
                            ))}
                          </ul>
                        </li>

                        <li className="brand-logo"></li>
                        <li className="brand-logo"></li>
                        <li className="brand-logo"></li>
                        <li className="brand-logo">
                          <a
                            className={`navbar-brand ${
                              activeMenu == "home" ? "active" : ""
                            }`}
                            href="/home"
                          >
                            <img src="/assets/images/meridian.png" alt="" />
                          </a>
                        </li>
                        <li className="brand-logo"></li>
                        <li>
                          {" "}
                          <a
                            className={
                              activeMenu == "contactus" ? "active" : ""
                            }
                            href="/ContactUs"
                          >
                            Contact US
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={openModal}>
                            Inquiry
                          </a>
                        </li>

                        <li>
                          <a
                            className={
                              activeMenu == "design-decor" ? "active" : ""
                            }
                            //href="#"
                            href="/design-decor"
                          >
                            Design/Decor
                          </a>
                        </li>
                        <li>
                          <a
                            className={activeMenu == "vendor" ? "active" : ""}
                            href="/vendor"
                          >
                            Vendor
                          </a>
                          {/* <a
                            className={activeMenu == "vendor" ? "active" : ""}
                            href="#"
                          >
                            Vendor
                          </a> */}
                        </li>
                        <li className={`menu-item-has-children`}>
                          <a
                            className={activeMenu == "blogs" ? "active" : ""}
                            href="#"
                          >
                            Blog
                          </a>
                          <ul className="sub-menu">
                            <li>
                              <a
                                className={`${
                                  activeMenu == "blogs" && activeMenuid == 2
                                    ? "active"
                                    : ""
                                }`}
                                href="/Blogs/2"
                              >
                                Quinceañera
                              </a>
                            </li>
                            <li>
                              <a
                                className={` ${
                                  activeMenu == "blogs" && activeMenuid == 3
                                    ? "active"
                                    : ""
                                }`}
                                href="/Blogs/3"
                              >
                                Wedding
                              </a>
                            </li>
                            <li>
                              <a
                                className={`${
                                  activeMenu == "blogs" && activeMenuid == 4
                                    ? "active"
                                    : ""
                                }`}
                                href="/Blogs/4"
                              >
                                Corporate
                              </a>
                            </li>
                            <li className="menu-item-has-children">
                              <a
                                className={` ${
                                  activeMenu == "blogs" && activeMenuid == 5
                                    ? "active"
                                    : ""
                                }`}
                                href="/Blogs/5"
                              >
                                Private Parties
                              </a>
                              <ul className="sub-menu sub-menu-Dum1">
                                <li>
                                  <a
                                    className={` ${
                                      activeMenu == "blogs" &&
                                      activeMenuid == 15
                                        ? "active"
                                        : ""
                                    }`}
                                    href="/Blogs/15"
                                  >
                                    Birthday
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={` ${
                                      activeMenu == "blogs" &&
                                      activeMenuid == 16
                                        ? "active"
                                        : ""
                                    }`}
                                    href="/Blogs/16"
                                  >
                                    Baby Shower
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={` ${
                                      activeMenu == "blogs" &&
                                      activeMenuid == 17
                                        ? "active"
                                        : ""
                                    }`}
                                    href="/Blogs/17"
                                  >
                                    Graduation
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={` ${
                                      activeMenu == "blogs" &&
                                      activeMenuid == 18
                                        ? "active"
                                        : ""
                                    }`}
                                    href="/Blogs/18"
                                  >
                                    Engagement
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={`${
                                      activeMenu == "blogs" &&
                                      activeMenuid == 19
                                        ? "active"
                                        : ""
                                    }`}
                                    href="/Blogs/19"
                                  >
                                    Others
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="mobile"
                    className="col-lg-3 col-md-2 col-2"
                    style={{ marginLeft: "20px" }}
                  >
                    <div className="header-right">
                      <div className="header-search-form-wrapper">
                        <div className="cart-search-contact">
                          <button
                            title="Brochure Download"
                            style={{ marginRight: "10px" }}
                            onClick={toggleDropdown}
                          >
                            <i className="fa fa-download icon-size iconColor" />
                          </button>

                          {isDropdownVisible && (
                            <ul
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: "-300%",
                                marginTop: "5px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                listStyleType: "none",
                                padding: "10px",
                                borderRadius: "4px",
                                zIndex: 1000,
                                width: "200px",
                              }}
                            >
                              <li
                                style={{
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #ddd",
                                  fontSize: "16px",
                                }}
                                onClick={() => ShandleDownload()}
                              >
                                {isLoading ? (
                                  <img
                                    src="/assets/images/ajax-loader.gif"
                                    alt="Loading..."
                                    title="Downloading..."
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      justifyContent: "center",
                                      display: "flex",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  "Social brochure"
                                )}
                              </li>
                              <li
                                style={{
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => ChandleDownload()}
                              >
                                {CisLoading ? (
                                  <img
                                    src="/assets/images/ajax-loader.gif"
                                    alt="Loading..."
                                    title="Downloading..."
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  "Corporate brochure"
                                )}
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>
                      <div className="mini-cart">
                        <a href="/paymentMethods" title="Payment">
                          <button
                            className="cart-toggle-btn"
                            style={{ marginRight: "10px" }}
                          >
                            <i className="fa fa-usd icon-size iconColor" />
                          </button>
                        </a>
                      </div>

                      <div className="mini-cart">
                        <a
                          title="Call Us"
                          href="tel:+1234567890"
                          className="cart-toggle-btn"
                        >
                          <i className="fa fa-phone icon-size iconColor" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end of container */}
            </nav>
          </div>
        </header>

        {/* end of header */}

        <div className="Container-fluid">
          <Routes>
            <Route path="*" Component={HomePage} />
            <Route path="/" Component={HomePage} />
            <Route path="/home" Component={HomePage} />
            <Route
              path="/ContactUs"
              element={<ContactUS_Page openModal={openModal} />}
            />
            <Route path="/About-us" Component={AboutusPage} />
            <Route path="/quinceanera" Component={Quincenera} />
            <Route path="/wedding" Component={Wedding} />
            <Route path="/privateParties" Component={PrivateParties} />
            <Route path="/birthday" Component={birthday} />
            <Route path="/babyShower" Component={babyShower} />
            <Route path="/graduation" Component={graduation} />
            <Route path="/engagement" Component={engagement} />
            <Route path="/others" Component={others} />
            <Route path="/Blogs" Component={BlogPage} />
            <Route path="/Blogs/:id" Component={BlogPage} />
            <Route path="/blogdetail/:blogid" element={<IndividualBlog />} />
            <Route path="/FAQ" Component={FAQFront} />
            <Route path="/termsandconditions" Component={TermsandConditionF} />
            <Route
              path="/siteMaps"
              element={<SiteMaps openModal={openModal} />}
            />
            <Route path="/privacypolicy" Component={PrivacyPolicyFront} />
            <Route path="/gallery/:galleryid/:Cat" element={<GalleryPage />} />
            <Route
              path="/gallerydetails/:title/:galid"
              element={<GalleryDetailsPage />}
            />
            <Route
              path="/facilityMain/:facilityId"
              element={<FacilityMain />}
            />
            <Route path="/vendor" Component={Vendor} />
            <Route path="/design-decor" Component={designAndDecor} />
            <Route path="/paymentMethods" Component={PaymentMethods} />
          </Routes>
        </div>

        <div className="color-switcher-wrap">
          <div className="floating-icons-wrap">
            <ul className="floating-icons">
              <li
                className="icon-btn"
                title="Brochure"
                ref={dropdownRef}
                onClick={() => setIsOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <a onClick={(e) => e.preventDefault()}>
                  <i className="fa fa-newspaper-o icon-size" />
                  <span className="icon-label">Smart Brochure</span>
                </a>

                {isOpen && (
                  <div className="dropdown-container">
                    <ul className="brochure-dropdown">
                      <li
                        style={{
                          fontSize: "16px",
                          padding: "0px 44px",
                          cursor: "pointer",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <a
                          href={socialLinks?.broucherLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Social Events
                        </a>
                      </li>
                      <li
                        style={{
                          fontSize: "16px",
                          padding: "0px 43px",
                          cursor: "pointer",
                        }}
                      >
                        <a
                          href={socialLinks?.corporateBroucherLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Corporate Events
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              <li
                className="icon-btn"
                title={`Contact Us:${socialLinks && socialLinks.contact}`}
              >
                <a href={`tel:${socialLinks && socialLinks.contact}`}>
                  <i className="fa fa-phone icon-size" />
                  <span className="icon-label">{socialLinks?.contact}</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="Email Us"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.emailId) {
                    window.location.href = `mailto:${socialLinks.emailId}`;
                  }
                }}
              >
                <a
                  href={`mailto:${socialLinks?.emailId}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <i className="fa fa-envelope icon-size" />
                  <span className="icon-label">Email Us</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="Play Store"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.playStoreURL) {
                    window.open(
                      socialLinks.playStoreURL,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                <a
                  href={socialLinks?.playStoreURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="fa fa-android icon-size" />
                  <span className="icon-label">Play Store</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="App Store"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.appStoreURL) {
                    window.open(
                      socialLinks.appStoreURL,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                <a
                  href={socialLinks?.appStoreURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="fa fa-apple icon-size" />
                  <span className="icon-label">App Store</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="Inquiry"
                onClick={openModal}
                style={{ cursor: "pointer" }}
              >
                <a onClick={(e) => e.preventDefault()}>
                  <i className="fa fa-paper-plane icon-size" />
                  <span className="icon-label">Inquiry</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div id="wpo-banner-section-Dublicate">
          <div className="wpo-site-footer text-center">
            <div className="container ">
              <div className="row home">
                <div className="col-12 footer-link">
                  <div className="row footer">
                    <div className="col-lg-3 col-md-6 col-sm-12 footer-image">
                      <a
                        className={`logo ${
                          activeMenu == "home" ? "active" : ""
                        }`}
                        href="/home"
                      >
                        <img
                          src="/assets/images/meridian.png"
                          id="footer-meridian-Png"
                          alt=""
                        />
                      </a>

                      {/* Footer Content Inside the Same Div */}
                      <div className="footer-link">
                        <div className="row">
                          <div className="col-lg-12 col-md-6 col-sm-12">
                            <ul>
                              <li>
                                <h5 className="Footer-title">Address</h5>
                                <ul>
                                  <li className="Footer-title-list">
                                    {ContactList != null &&
                                      ContactList.length > 0 &&
                                      ContactList.map(
                                        (contact, index) =>
                                          contact.contactType == "Address" && (
                                            <p key={index}>{contact.details}</p>
                                          )
                                      )}
                                    {socialLinks && socialLinks.contact && (
                                      <p className="Footer-title-list">
                                        <a href={`tel:${socialLinks.contact}`}>
                                          {socialLinks.contact}
                                        </a>
                                      </p>
                                    )}
                                  </li>
                                </ul>
                              </li>
                            </ul>

                            <ul>
                              <li className="link-widget">
                                <h5
                                  id="Footer-CallToAction-title"
                                  className="Footer-title"
                                >
                                  Reach Us
                                </h5>
                                <ul id="Footer-icon-ul">
                                  <li>
                                    <a
                                      title="Contact Us"
                                      href="tel:+91 1234567890"
                                    >
                                      <i className="fi flaticon-phone-call" />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      title="Mail"
                                      href={`mailto:${socialLinks?.emailId}`}
                                    >
                                      <i className="fa fa-envelope icon-size"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      title="Inquiry"
                                      href="#"
                                      onClick={openModal}
                                    >
                                      <i className="fa fa-paper-plane icon-size"></i>
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-sm-12">
                      <ul>
                        <li>
                          <h5 className="Footer-title">Quik Links</h5>
                          <ul>
                            <li className="Footer-title-list ">
                              <a
                                href="/home"
                                className={`Footer-title-list-value ${
                                  activeMenu == "home" ? "active" : ""
                                }`}
                              >
                                Home
                              </a>
                              <br />
                              <a
                                href="/About-us"
                                className={`Footer-title-list-value ${
                                  activeMenu == "about-us" ? "active" : ""
                                }`}
                              >
                                About Us
                              </a>
                              <br />
                              <a
                                className={`Footer-title-list-value ${
                                  activeMenu == "contactus" ? "active" : ""
                                }`}
                                href="/ContactUs"
                              >
                                Contact US
                              </a>
                              <br />
                              {/* <a
                                  className={`Footer-title-list-value ${
                                    activeMenu == "vendor" ? "active" : ""
                                  }`}
                                  href="/vendor"
                                >
                                  Vendor
                                </a> */}
                              <a
                                className={`Footer-title-list-value ${
                                  activeMenu == "vendor" ? "active" : ""
                                }`}
                                href="/vendor"
                              >
                                Vendor
                              </a>
                              <br />
                              <a
                                href="/Blogs/2"
                                className={`Footer-title-list-value ${
                                  activeMenu == "blogs" ? "active" : ""
                                }`}
                              >
                                Blog
                              </a>
                              <br />
                              <a
                                href="/FAQ"
                                className={`Footer-title-list-value ${
                                  activeMenu == "faq" ? "active" : ""
                                }`}
                              >
                                FAQ
                              </a>
                              <br />
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-12">
                      <ul>
                        <li>
                          <h5 className="Footer-title">Events</h5>
                          <ul>
                            <li className="Footer-title-list">
                              <a
                                className={`Footer-title-list-value ${
                                  activeMenu == "quinceanera" ? "active" : ""
                                }`}
                                href="/quinceanera"
                              >
                                Quinceanera
                              </a>
                              <br />
                              <a
                                className={`Footer-title-list-value ${
                                  activeMenu == "wedding" ? "active" : ""
                                }`}
                                href="/wedding"
                              >
                                Wedding
                              </a>
                              <br />
                              <a
                                href="/corporate"
                                className="Footer-title-list-value"
                              >
                                Corporate / Business Meetings
                              </a>
                              <br />
                              <a
                                href="/privateParties"
                                className={`Footer-title-list-value ${
                                  activeMenu == "privateparties" ? "active" : ""
                                }`}
                              >
                                Private Parties / Others
                              </a>
                              <br />
                              <a
                                href="/design-decor"
                                className="Footer-title-list-value"
                              >
                                Design/Decor
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-12">
                      <ul>
                        <li>
                          <h5 className="Footer-title">Gallery</h5>
                          <ul>
                            <li className="Footer-title-list">
                              {BallroomData.map((ballroom) => (
                                <>
                                  <a
                                    className={`Footer-title-list-value ${
                                      activeMenu == "gallery" &&
                                      activeMenuid == `${ballroom.facilityID}`
                                        ? "active"
                                        : ""
                                    }`}
                                    href={`/gallery/${ballroom.facilityID}/BallRoom`}
                                  >
                                    {ballroom.facilityName}
                                  </a>
                                  <br />
                                </>
                              ))}
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-12 footer-followUs">
                      {remainingIcons.length > 0 && (
                        <div className="link-widget" id="Action">
                          <h5 className="Footer-title">Follow Us</h5>
                          <div className="social-icons-container">
                            {remainingIcons.map((link, index) => (
                              <a
                                title={link.name}
                                key={index}
                                href={link.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="follow-icon"
                              >
                                <img
                                  src={`${ImageURL}${link.imagePath}`}
                                  alt={link.name}
                                />
                              </a>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 col-md-6  copyright">
                      <p id="footer-copyright">
                        © Copyright {new Date().getFullYear()} |{" "}
                        <a
                          className={activeMenu == "home" ? "active" : ""}
                          href="/home"
                          id="meridian-copyright"
                        >
                          {" "}
                          Meridian{" "}
                        </a>{" "}
                        | All right reserved.
                      </p>
                    </div>
                    <div className="col-lg-6 col-sm-12 col-md-6 Plolicy">
                      <p id="footer-policy-Terms">
                        <a
                          href="/siteMaps"
                          id="footer-policy"
                          className={`Footer-title-list-value ${
                            activeMenu == "privacypolicy" ? "active" : ""
                          }`}
                        >
                          Site Mapping
                        </a>
                        <a
                          href="/privacypolicy"
                          id="footer-policy"
                          className={`Footer-title-list-value ${
                            activeMenu == "privacypolicy" ? "active" : ""
                          }`}
                        >
                          Privacy Policy
                        </a>
                        <a
                          href="/termsandconditions"
                          className={`Footer-title Footer-title-list Footer-title-list-value ${
                            activeMenu == "termsandconditions" ? "active" : ""
                          }`}
                        >
                          Terms and Conditions
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modal Inquiry */}
      <div
        className="modal custom-modaal fade"
        id="inquiry"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "100%" }}
        >
          <div
            className="modal-content"
            style={{
              maxWidth: "1100px",
              marginLeft: "180px",
              margin: "0% auto",
              marginTop: "0px",
            }}
          >
            {loadComponent &&
              React.cloneElement(loadComponent, { key: CloseModal })}
          </div>
        </div>
      </div>
      {/* modal Inquiry */}
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true}
        pauseOnHover={false}
        draggable={false}
        closeOnClick={false}
      />
    </>
  );
};
